import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import type { Location } from 'react-router-dom'
import type { Playlist } from 'types/playlist'
import { loadPlaylistStats } from '@disco/state-management/actions/PlaylistStatsActions'
import { PLAYLIST_STATS_WITH_HOVER } from '@disco/constants/FeatureTypes'
import type { featureData } from '@disco/state-management/selectors/business'
import { useFeatureData } from '@disco/state-management/selectors/business'
import { getPlaylist } from '@disco/state-management/selectors/playlists'
import PlaylistStats from './PlaylistStats'
type Props = {
  location: Location
  params: {
    playlistId: string
  }
}

const PlaylistStatsContainer = ({
  params,
  location,
}: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const playlistId: number = parseInt(params.playlistId, 10)
  const { isFeatureEnabled, isTrial }: featureData = useFeatureData(
    PLAYLIST_STATS_WITH_HOVER,
  )
  useEffect(() => {
    dispatch(loadPlaylistStats(playlistId))
  }, [dispatch, playlistId])
  const playlist: Playlist = useSelector(state =>
    getPlaylist(state, {
      id: playlistId,
    }),
  )
  const navigate = useNavigate()
  const closeModal = useCallback(() => {
    const returnPath = location.state?.returnTo ?? '/'
    navigate(returnPath)
  }, [navigate, location])
  const props = {
    isTrial,
    isFeatureEnabled,
    playlist,
  }
  return <PlaylistStats {...props} onClose={closeModal} />
}

export default PlaylistStatsContainer
